import { RehabStoreState, ChoiceListStoreState } from './rehab.types';
import { moduleNamespace } from '@Store/config.store';
import { UtilStoreState } from './utils.types';
import { RiskStoreState } from './risk.types';

export interface StoreState {
	RehabStore: RehabStoreState;
	ChoiceListStore: ChoiceListStoreState;
	util: UtilStoreState;
	RiskStore: RiskStoreState;
}

export interface NamespacedStoreState {
	[moduleNamespace]: StoreState;
}

export type PartialStoreState = {};

export interface NamespacedPartialStoreState {
	[moduleNamespace]: PartialStoreState;
}
